import { render, staticRenderFns } from "./page_list.vue?vue&type=template&id=1422a7aa&scoped=true&"
import script from "./page_list.vue?vue&type=script&lang=js&"
export * from "./page_list.vue?vue&type=script&lang=js&"
import style0 from "./page_list.vue?vue&type=style&index=0&id=1422a7aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422a7aa",
  null
  
)

export default component.exports